import * as React from "react";
const SvgSecure = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="secure_svg__svg1"
    viewBox="0 0 185.208 111.125"
    {...props}
  >
    <defs id="secure_svg__defs1">
      <style id="style1-3">
        {".secure_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3aaf3c}"}
      </style>
    </defs>
    <g id="secure_svg__layer1">
      <path
        id="secure_svg__path1"
        d="m44.59 47.73-17.066.037v29.28"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.264583,
          strokeDasharray: "1.05833,.264583",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <rect
        id="secure_svg__rect1"
        width={177.011}
        height={13.568}
        x={4.099}
        y={7.819}
        ry={2.755}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.411475,
        }}
      />
      <rect
        id="secure_svg__rect2"
        width={23.753}
        height={6.183}
        x={10.64}
        y={11.968}
        ry={1.643}
        style={{
          fill: "#969696",
          fillOpacity: 1,
          strokeWidth: 0.264583,
        }}
      />
      <circle
        id="secure_svg__path2"
        cx={16.456}
        cy={14.921}
        r={1.25}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.165914,
        }}
      />
      <circle
        id="secure_svg__path2-8"
        cx={22.66}
        cy={14.921}
        r={1.25}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.165914,
        }}
      />
      <circle
        id="secure_svg__path2-3"
        cx={28.907}
        cy={14.921}
        r={1.25}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.165914,
        }}
      />
      <path
        id="secure_svg__path3"
        d="M14.509 62.109h31.987"
        style={{
          fill: "#000",
          fillOpacity: 1,
          stroke: "#000",
          strokeWidth: 0.265,
          strokeDasharray: "1.06,.265",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path3-4"
        d="M44.59 61.85h44.884"
        style={{
          fill: "#000",
          fillOpacity: 1,
          stroke: "#3aaf3c",
          strokeWidth: 0.313905,
          strokeDasharray: "1.25561,.313905",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path5"
        d="M27.524 77.047H44.59"
        style={{
          fill: "none",
          fillOpacity: 1,
          stroke: "#000",
          strokeWidth: 0.264999,
          strokeDasharray: "1.06,.264999",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <rect
        id="secure_svg__rect1-5"
        width={21.206}
        height={11.102}
        x={33.987}
        y={41.62}
        ry={3.933}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.128826,
        }}
      />
      <rect
        id="secure_svg__rect1-2"
        width={21.206}
        height={11.102}
        x={33.987}
        y={56.558}
        ry={3.933}
        style={{
          fill: "#88154f",
          fillOpacity: 1,
          strokeWidth: 0.128826,
        }}
      />
      <rect
        id="secure_svg__rect1-2-6"
        width={21.206}
        height={11.102}
        x={3.905}
        y={56.558}
        ry={3.933}
        style={{
          fill: "#88154f",
          fillOpacity: 1,
          strokeWidth: 0.128826,
        }}
      />
      <rect
        id="secure_svg__rect1-7"
        width={21.206}
        height={11.102}
        x={33.987}
        y={71.496}
        ry={3.933}
        style={{
          fill: "#d8d8d8",
          fillOpacity: 1,
          strokeWidth: 0.128826,
        }}
      />
      <g
        id="secure_svg__g1"
        style={{
          clipRule: "evenodd",
          fillRule: "evenodd",
          imageRendering: "optimizeQuality",
          shapeRendering: "geometricPrecision",
          textRendering: "geometricPrecision",
          fill: "#f81111",
          fillOpacity: 1,
        }}
        transform="matrix(.04353 0 0 .04353 145.064 25.799)"
      >
        <path
          id="secure_svg__path1-1"
          fillRule="nonzero"
          d="M362.984 94.437c-19.862-33.342-47.592-54.122-77.309-64.116-23.792-8.001-48.898-9.157-72.283-4.368-23.25 4.76-44.772 15.407-61.54 31.037-19.898 18.547-33.108 44.252-34.479 75.573-.275 6.379-5.671 11.327-12.05 11.051l-.27-.014c-36.271-2.415-61.087 15.051-73.173 39.229-4.981 9.968-7.873 21.128-8.572 32.561-.704 11.484.798 23.161 4.601 34.11l.156.484c9.972 28.2 35.607 51.831 78.585 55.22q-.113 3.334-.187 6.773a424 424 0 0 0-.027 16.359c-.453.022-.915.014-1.378-.02-53.627-4.178-85.906-34.404-98.734-70.573l-.244-.633C1.243 243.184-.674 228.44.208 214.032c.886-14.457 4.599-28.69 11.017-41.53 14.668-29.34 43.134-51.235 83.99-52.233 4.049-32.805 19.182-60 40.875-80.219 19.884-18.535 45.299-31.139 72.682-36.744 27.25-5.58 56.508-4.234 84.241 5.093 36.237 12.188 69.818 37.893 92.847 79.406 23.908-4.704 45.073-1.653 62.972 6.763 25.016 11.765 43.251 33.896 53.516 60.032 10.06 25.617 12.507 55.278 6.155 82.709-10.119 43.697-42.088 81.838-100.456 90.053-.521.053-1.047.09-1.585.09l-1.563.004c.387-5.027.599-10.184.599-15.479 0-2.576-.059-5.11-.151-7.623h.112c46.796-6.81 72.409-37.306 80.489-72.206 5.303-22.908 3.253-47.697-5.161-69.124-8.215-20.916-22.46-38.468-41.738-47.532-28.509-13.405-68.907-8.536-118.729 30.611-5.026 3.951-12.308 3.077-16.259-1.948s-3.078-12.307 1.948-16.259c20.127-15.813 39.175-26.693 56.975-33.459M318.54 284.585c5.804 0 10.513 4.706 10.513 10.513 0 5.804-4.709 10.513-10.513 10.513-5.807 0-10.513-4.709-10.513-10.513 0-5.807 4.706-10.513 10.513-10.513m0 121.316c5.804 0 10.513 4.708 10.513 10.512 0 5.807-4.709 10.513-10.513 10.513-5.807 0-10.513-4.706-10.513-10.513 0-5.804 4.706-10.512 10.513-10.512m0-59.425c5.804 0 10.513 4.706 10.513 10.513 0 5.804-4.709 10.513-10.513 10.513-5.807 0-10.513-4.709-10.513-10.513 0-5.807 4.706-10.513 10.513-10.513m-131.753-90.354c17.548 5.857 41.973 9.483 69.107 9.483 27.137 0 51.558-3.626 69.11-9.483 15.404-5.142 24.933-11.368 24.933-17.457s-9.529-12.314-24.933-17.456c-17.549-5.858-41.973-9.483-69.11-9.483-27.134 0-51.559 3.625-69.107 9.483-32.683 10.91-33.581 23.703 0 34.913m163.187 124.074c-5.488 3.754-12.476 7.063-20.739 9.821-18.905 6.311-44.846 10.214-73.341 10.214s-54.434-3.903-73.339-10.214c-8.158-2.724-15.107-5.982-20.563-9.677v40.042c1.215 5.678 10.46 11.401 24.792 16.185 17.551 5.858 41.976 9.483 69.11 9.483 27.137 0 51.558-3.625 69.11-9.483 10.637-3.549 18.474-7.618 22.303-11.8 3.16-3.453 2.667-5.724 2.667-9.848zM148.482 238.665c0-12.48 13.021-23.068 34.073-30.095 18.905-6.31 44.846-10.215 73.339-10.215 28.495 0 54.436 3.905 73.341 10.215 19.163 6.397 31.67 15.743 33.759 26.784.251.701.387 1.456.387 2.245v184.278c0 12.774-24.407 24.078-34.146 27.331-18.905 6.308-44.846 10.214-73.341 10.214s-54.434-3.906-73.339-10.214c-9.967-3.328-33.934-14.262-33.934-27.331v-4.283c0-59.641-.139-119.297-.139-178.929m13.51 122.526c1.215 5.677 10.46 11.401 24.792 16.185 17.551 5.858 41.976 9.483 69.11 9.483 27.137 0 51.558-3.625 69.11-9.483 15.404-5.141 24.933-11.367 24.933-17.456h.073v-38.915c-5.488 3.756-12.512 7.063-20.775 9.821-18.905 6.311-44.846 10.213-73.341 10.213s-54.434-3.902-73.339-10.213c-8.158-2.724-15.107-5.982-20.563-9.675zm0-59.191c1.215 5.678 10.46 11.401 24.792 16.186 17.551 5.857 41.976 9.483 69.11 9.483 27.137 0 51.558-3.623 69.11-9.483 15.404-5.142 24.933-11.368 24.933-17.457h.073v-41.788c-5.488 3.754-12.512 7.06-20.775 9.819-18.905 6.31-44.846 10.215-73.341 10.215-28.493 0-54.434-3.905-73.339-10.215-8.158-2.722-15.107-5.979-20.563-9.676z"
          style={{
            fill: "#f81111",
            fillOpacity: 1,
          }}
        />
      </g>
      <path
        id="secure_svg__path1-7"
        d="M144.864 54.2h22.807c.361 0 .655.295.655.656v15.109a.657.657 0 0 1-.655.655h-22.807a.657.657 0 0 1-.655-.655v-15.11c0-.36.294-.655.655-.655m8.43 17.325h5.947c.016 1.028.44 1.95 1.588 2.675h-9.123c.919-.665 1.592-1.474 1.588-2.675m2.974-3.113a.842.842 0 1 1 0 1.684.842.842 0 0 1 0-1.684M146.18 55.435h20.175a.58.58 0 0 1 .579.579v11.29a.58.58 0 0 1-.58.578h-20.174a.58.58 0 0 1-.579-.579v-11.29a.58.58 0 0 1 .58-.578"
        className="secure_svg__st0"
        style={{
          strokeWidth: 0.19627,
          fill: "#f81111",
          fillOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path1-6"
        d="M160.501 93.04h-5.918a.34.34 0 0 1-.34-.34v-1.837a.34.34 0 0 1 .34-.338h5.918a.34.34 0 0 1 .339.338V92.7a.34.34 0 0 1-.339.338zm-1.799-7.665h-.538v-1.387h.538zm1.599 0h-.539v-1.387h.539zm-5.139.055a.752.752 0 1 1 .752-.75.75.75 0 0 1-.752.75m-6.498 14.085a.4.4 0 0 0 .231.347l3.917 2.023a.4.4 0 0 0 .179.044h.022l9.08.027a.38.38 0 0 0 .376-.379V82.334a.38.38 0 0 0-.376-.378h-9.116l-4.111 2.116a.38.38 0 0 0-.202.337zm.759-14.858 3.188-1.688v17.977l-3.19-1.667V84.657zm3.945-1.944h8.347v18.49l-8.347-.03zm7.133 6.775h-5.918a.34.34 0 0 1-.339-.339v-1.837a.34.34 0 0 1 .339-.339h5.918a.34.34 0 0 1 .339.339v1.836a.34.34 0 0 1-.339.34m-5.372-.952a.306.306 0 1 1 .306-.306.306.306 0 0 1-.306.306m2.574.195h-.388V87.73h.386v1.001zm1.15 0h-.388V87.73h.385v1.001zm1.148 0h-.387V87.73H160v1.001zm.502 11.412h-5.92a.34.34 0 0 1-.339-.338v-1.838a.34.34 0 0 1 .339-.339h5.918a.34.34 0 0 1 .339.339v1.838a.34.34 0 0 1-.339.338zm-5.372-.95a.308.308 0 1 1 .303-.308.306.306 0 0 1-.306.306zm2.574.193h-.39v-1h.386v1zm1.149 0h-.39v-1h.386v1zm1.149 0h-.39v-1H160v1zm.501-2.795h-5.921a.34.34 0 0 1-.339-.338v-1.838a.34.34 0 0 1 .339-.338h5.918a.34.34 0 0 1 .339.338v1.838a.34.34 0 0 1-.339.338zm-5.371-.95a.308.308 0 1 1 .306-.308.306.306 0 0 1-.306.308m2.573.194h-.39v-1.002h.385v1.002zm1.15 0h-.391v-1.002h.385v1.002zm1.149 0h-.391v-1.002H160v1.002zm-4.872-3.744a.308.308 0 1 1 .306-.308.31.31 0 0 1-.306.308m2.573.193h-.39v-1.002h.385v1Zm1.15 0h-.391v-1.002h.385v1Zm1.149 0h-.391v-1.002H160v1Z"
        style={{
          fillRule: "evenodd",
          strokeWidth: 0.162774,
          fill: "#000",
          fillOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path4"
        d="M89.474 61.85V35.798h22.91"
        style={{
          fill: "none",
          stroke: "#f81111",
          strokeWidth: 0.264583,
          strokeDasharray: "1.05833,.264583",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path7"
        d="M143.41 62.278h-16.018"
        style={{
          fill: "none",
          stroke: "#f10000",
          strokeWidth: 0.494242,
          strokeDasharray: "1.97696805,.49424201",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path7-8"
        d="M144.522 92.391h-16.019"
        style={{
          fill: "none",
          stroke: "#24cd2c",
          strokeWidth: 0.494242,
          strokeDasharray: "1.97697,.494242",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path7-5"
        d="M144.132 35.763h-16.019"
        style={{
          fill: "none",
          stroke: "#f10000",
          strokeWidth: 0.494242,
          strokeDasharray: "1.97697,.494242",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path1-15"
        fill="#ff4141"
        fillRule="evenodd"
        d="M120.165 56.804a5.351 5.351 0 1 1 0 10.703 5.351 5.351 0 0 1 0-10.703m1.047 3.41a.61.61 0 0 1 .87-.002c.24.242.241.635.001.878l-1.05 1.066 1.051 1.067a.62.62 0 0 1-.007.873.61.61 0 0 1-.867-.001l-1.044-1.06-1.047 1.062a.61.61 0 0 1-.87.002.625.625 0 0 1-.002-.878l1.05-1.066-1.051-1.067a.62.62 0 0 1 .007-.872.61.61 0 0 1 .867 0l1.045 1.06z"
        clipRule="evenodd"
        style={{
          strokeWidth: 0.0871003,
        }}
      />
      <path
        id="secure_svg__path1-15-4"
        fill="#ff4141"
        fillRule="evenodd"
        d="M120.864 29.939a5.351 5.351 0 1 1 0 10.702 5.351 5.351 0 0 1 0-10.702m1.046 3.41a.61.61 0 0 1 .87-.003c.24.242.242.635.002.879l-1.05 1.066 1.051 1.066a.62.62 0 0 1-.007.873.61.61 0 0 1-.867 0l-1.045-1.06-1.047 1.061a.61.61 0 0 1-.87.003.625.625 0 0 1-.001-.879l1.05-1.065-1.051-1.067a.62.62 0 0 1 .007-.873.61.61 0 0 1 .867 0l1.044 1.06z"
        clipRule="evenodd"
        style={{
          strokeWidth: 0.0871003,
        }}
      />
      <path
        id="secure_svg__path1-10"
        d="M121.104 87.704a5.485 5.485 0 1 1 0 10.97 5.485 5.485 0 0 1 0-10.97m-1.96 5.069c.41.237.677.433.996.784.824-1.329 1.72-2.064 2.885-3.11l.114-.043h1.275c-1.709 1.898-3.034 3.463-4.22 5.751-.619-1.32-1.17-2.231-2.4-3.077z"
        className="secure_svg__st0"
        style={{
          strokeWidth: 0.0892674,
        }}
      />
      <path
        id="secure_svg__path8"
        d="M89.5 61.858V93.18h23.102"
        style={{
          fill: "none",
          fillOpacity: 1,
          stroke: "#3aaf3c",
          strokeWidth: 0.298731,
          strokeDasharray: "1.19492,.298731",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
      <path
        id="secure_svg__path9"
        d="M89.474 61.85h22.778"
        style={{
          fill: "none",
          fillOpacity: 1,
          stroke: "#f81111",
          strokeWidth: 0.296715,
          strokeDasharray: "1.18686,.296715",
          strokeDashoffset: 0,
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
);
export default SvgSecure;
